const navigation = {
  id: 'group-dashboard-loading-unique',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'menu.dashboard',
      type: 'item',
      icon: 'ph ph-house-line',
      url: '/'
    }
  ]
};

export default navigation;